import React from 'react';
import { useWallet } from '../context/WalletContext';
import '../styles/wallet-modal.css';

const WalletModal = ({ isOpen, onClose, onSuccess }) => {
  const { connectWallet, isConnecting, error, isMetaMaskInstalled } = useWallet();

  const handleConnect = async () => {
    await connectWallet();
    if (onSuccess) {
      onSuccess();
    } else {
      onClose();
    }
  };

  const handleInstallMetaMask = () => {
    window.open('https://metamask.io/download.html', '_blank');
  };

  if (!isOpen) return null;

  return (
    <div className="wallet-modal-overlay">
      <div className="wallet-modal">
        <div className="wallet-modal-header">
          <h2>Connect Wallet</h2>
          <button className="close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="wallet-modal-content">
          {error && (
            <div className="wallet-error">
              <i className="fas fa-exclamation-circle"></i>
              <span>{error}</span>
            </div>
          )}

          <div className="wallet-options">
            <div className="wallet-option" onClick={isMetaMaskInstalled ? handleConnect : handleInstallMetaMask}>
              <div className="wallet-icon">
                <img src="/images/metamask-fox.svg" alt="MetaMask" />
              </div>
              <div className="wallet-info">
                <h3>MetaMask</h3>
                <p>Connect to your MetaMask wallet</p>
              </div>
              <button className="wallet-connect-btn" disabled={isConnecting}>
                {isConnecting ? (
                  <i className="fas fa-spinner fa-spin"></i>
                ) : isMetaMaskInstalled ? (
                  'Connect'
                ) : (
                  'Install'
                )}
              </button>
            </div>

            <div className="wallet-option disabled">
              <div className="wallet-icon">
                <img src="/images/walletconnect.svg" alt="WalletConnect" />
              </div>
              <div className="wallet-info">
                <h3>WalletConnect</h3>
                <p>Connect using WalletConnect</p>
              </div>
              <button className="wallet-connect-btn" disabled>
                Coming Soon
              </button>
            </div>

            <div className="wallet-option disabled">
              <div className="wallet-icon">
                <img src="/images/coinbase-wallet.svg" alt="Coinbase Wallet" />
              </div>
              <div className="wallet-info">
                <h3>Coinbase Wallet</h3>
                <p>Connect to your Coinbase Wallet</p>
              </div>
              <button className="wallet-connect-btn" disabled>
                Coming Soon
              </button>
            </div>
          </div>
        </div>

        <div className="wallet-modal-footer">
          <p>By connecting your wallet, you agree to our <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a>.</p>
        </div>
      </div>
    </div>
  );
};

export default WalletModal;
